import { render, staticRenderFns } from "./Partidas.vue?vue&type=template&id=b74d5e70&scoped=true"
import script from "./Partidas.vue?vue&type=script&lang=js"
export * from "./Partidas.vue?vue&type=script&lang=js"
import style0 from "./Partidas.vue?vue&type=style&index=0&id=b74d5e70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74d5e70",
  null
  
)

export default component.exports